const PLN = new Intl.NumberFormat('pl-PL', { style: 'currency', currency: 'PLN' });

/** "3 300,00 zł" - the app registers no Angular locale data for Polish, so the currency pipe cannot do it. */
export function formatPln(value: number | null | undefined): string {
  return PLN.format(value ?? 0);
}
